import * as React from 'react';
import PhoneInput from 'react-phone-number-input';
import styled from 'styled-components';

import { useFieldAccessibility } from '@hooks';

import { inputBase, inputBaseWrapper } from '../../../styles/common';
import { FieldProps } from '../../types';

import { Error } from './error';

import 'react-phone-number-input/style.css';

type BasePhoneNumberInputProps = Omit<
	Partial<FieldProps>,
	'value' | 'onChange' | 'onBlur' | 'autoComplete'
> &
	Omit<
		React.InputHTMLAttributes<HTMLInputElement>,
		'name' | 'autoComplete' | 'onBlur' | 'onChange' | 'type'
	>;

export interface PhoneNumberInputProps extends BasePhoneNumberInputProps {
	value?: string;
	onChange?(value: string): void;
	onBlur?(value: string): void;
}

const PhoneNumberInput = (props: PhoneNumberInputProps) => {
	const { name, value, onChange, onBlur, placeholder, error, disabled = false } = props;

	const { isInvalid, ...accessibility } = useFieldAccessibility<PhoneNumberInputProps>(props);

	return (
		<Wrapper aria-label={accessibility['aria-label']} data-invalid={isInvalid}>
			<StyledPhoneInput
				international
				disabled={disabled}
				name={name}
				value={value}
				onChange={onChange}
				onBlur={onBlur}
				placeholder={placeholder}
				{...accessibility}
			/>
			{isInvalid && <Error id={accessibility['aria-describedby']} error={error} />}
		</Wrapper>
	);
};

export default PhoneNumberInput;

const Wrapper = styled.label`
	${inputBaseWrapper()};
`;

const StyledPhoneInput = styled(PhoneInput)`
	${inputBase()};

	justify-content: flex-end;

	& > input {
		${inputBase()};

		width: calc(100% - 32px);

		padding: 0;
		border: none;
	}

	.PhoneInputInput {
		flex: initial;
	}

	.PhoneInputCountry {
		position: absolute;
		top: 50%;
		left: 0;

		margin-right: 0;

		transform: translateY(-50%);
	}

	.PhoneInputCountrySelect {
		z-index: 0;
	}
	.PhoneInputCountryIcon {
		height: 20px;
		width: 20px;
	}
	.PhoneInputCountrySelectArrow {
		display: none;
	}
	.PhoneInputCountryIconImg,
	.PhoneInputInternationalIconGlobe {
		color: ${(p) => p.theme.colors.orange1} !important;
	}
	.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {
		box-shadow: none;
	}
`;
